import { Link } from 'react-router-dom';
import { Button } from '~/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';

const stack = [
  { title: 'Фронтенд', hint: 'React + Rsbuild + TypeScript, Tailwind CSS 4, shadcn/ui' },
  { title: 'Бэкенд', hint: 'Fastify, слои route → service → repository' },
  { title: 'Данные', hint: 'managed SQLite через API платформы Айгентура' },
];

export function AboutPage() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="max-w-xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-slate-900">О проекте</h1>
          <Link to="/">
            <Button variant="ghost" size="sm">← На главную</Button>
          </Link>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Технический стек</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {stack.map((item) => (
              <div key={item.title} className="rounded-lg border border-slate-200 bg-white px-4 py-3">
                <div className="text-sm font-semibold text-slate-900">{item.title}</div>
                <div className="text-xs text-slate-500 mt-1 leading-relaxed">{item.hint}</div>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
